import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validateNumber,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

export default class OxygeneSaturationDeclaredJournalEvent extends JournalEvent {
  static override type = "oxygene-saturation-declared-journal-event";

  @attr("number") declare spo2: number;

  static override validations(intl: IntlService) {
    return {
      spo2: [
        validatePresence({
          presence: true,
          description: intl.t(
            "validations.oxygene-saturation-declared-journal-event.spo2"
          )
        }),
        validateNumber({
          gte: 50,
          lte: 100,
          description: intl.t(
            "validations.oxygene-saturation-declared-journal-event.spo2"
          )
        })
      ],
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.oxygene-saturation-declared-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----
  @belongsTo("patient", {
    async: false,
    inverse: "oxygeneSaturationDeclaredJournalEvents"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "oxygene-saturation-declared-journal-event": OxygeneSaturationDeclaredJournalEvent;
  }
}
